/* ─────────────────────────────────────────────────────────────────────────
   KIMDYMA · eb-product-card.js — compare selection and the bundle strip. v4.0

   Hand-written; replaces v1.0's, whose bundle markup (.eb-bundle-item input)
   was not the v3.4 markup (.eb-bundle__item[aria-pressed]) and whose copy was
   English hard-coded in the script. Copy comes from the markup's data
   attributes, which Liquid fills from the locale.

   COMPARE lives in localStorage so it survives navigation between the three
   product pages. The tray, when one is on the page, follows it.

   THE BUNDLE never moves the bike price. Toggling an accessory rewrites the
   total and the saving only; the total row is height-locked in CSS so a grid
   cannot jump. Add-to-cart on a campaign card posts the bike and every
   selected accessory in one request, so they arrive as one purchase.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.ebProductCardLoaded) return;
  window.ebProductCardLoaded = true;

  var slice = function (l) { return Array.prototype.slice.call(l); };
  var MAX = 3, KEY = 'eb-compare';

  function money(cents) {
    if (typeof window.ebMoney === 'function') return window.ebMoney(cents);
    var locale = document.documentElement.dataset.locale || 'en';
    var currency = document.documentElement.dataset.currency || 'EUR';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }

  /* ── compare ─────────────────────────────────────────────────────────── */
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function paintCompare() {
    var sel = read();
    slice(document.querySelectorAll('[data-eb-compare]')).forEach(function (btn) {
      var on = sel.some(function (m) { return m.handle === btn.getAttribute('data-eb-compare'); });
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* Not disabled at the limit any more: the fourth press is honoured by
         dropping the oldest, so refusing it would be refusing something that
         works. */
      btn.disabled = false;
      var label = btn.querySelector('[data-eb-compare-label]');
      if (label) label.textContent = on ? (btn.getAttribute('data-added') || label.getAttribute('data-on') || label.textContent)
                                        : (btn.getAttribute('data-add') || label.getAttribute('data-off') || label.textContent);
    });
    document.dispatchEvent(new CustomEvent('eb:compare:change', { detail: { selected: sel, max: MAX } }));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-eb-compare]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-eb-compare');
    var sel = read();
    var i = sel.findIndex(function (m) { return m.handle === handle; });
    if (i > -1) {
      sel.splice(i, 1);
    } else {
      /* A FOURTH REPLACES THE OLDEST, which is what layer 8 has said this
         does since v4.0 — "max three; a fourth replaces the oldest rather
         than failing silently". The code did fail silently: past three the
         click was dropped. A control that refuses a press it could honour
         teaches the visitor that the page is broken. */
      if (sel.length >= MAX) sel.shift();
      sel.push({
        handle: handle,
        name: btn.getAttribute('data-name') || handle,
        /* The tray draws a thumbnail, so the selection has to carry one.
           Without it every slot was an empty square with a remove button —
           which is what shipped. */
        image: btn.getAttribute('data-image') || ''
      });
    }
    write(sel);
    paintCompare();
  });
  window.ebCompare = { read: read, write: write, paint: paintCompare, max: MAX };

  /* ── bundle ──────────────────────────────────────────────────────────── */
  /* The saving is each row's data-save: what its bundle_offer states for this
     currency (a gift's is its whole price). The card never works one out. */
  function ticked(box) {
    return slice(box.querySelectorAll('[data-eb-bundle-item][aria-pressed="true"]'))
      .filter(function (it) { return !it.disabled; });
  }
  function recalc(box) {
    var base = parseInt(box.getAttribute('data-base'), 10) || 0;
    /* 活动卡上「省了多少」从车本身的划线差价算起：顾客看到的是这一单一共省多少，
       不只是配件那几行。没有这个属性的旧标记照旧从 0 算。 */
    var sum = base, saved = parseInt(box.getAttribute('data-base-save'), 10) || 0;
    ticked(box).forEach(function (it) {
      var p = parseInt(it.getAttribute('data-price'), 10) || 0;
      var s = Math.min(parseInt(it.getAttribute('data-save'), 10) || 0, p);
      sum += p - s; saved += s;
    });
    var total = box.querySelector('[data-eb-bundle-total]');
    var save = box.querySelector('[data-eb-bundle-save]');
    if (total) total.textContent = money(sum);
    if (save) save.textContent = saved ? (save.getAttribute('data-tpl') || '@@').replace('@@', money(saved)) : '';
  }
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-eb-bundle-head]');
    if (head) {
      var box = head.closest('[data-eb-bundle]');
      var open = box.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var item = e.target.closest('[data-eb-bundle-item]');
    if (item && !item.disabled && !item.hasAttribute('data-locked')) {
      item.setAttribute('aria-pressed', item.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      recalc(item.closest('[data-eb-bundle]'));
    }
  });
  slice(document.querySelectorAll('[data-eb-bundle]')).forEach(recalc);

  /* A campaign card's add posts the bike plus every selected accessory as one
     request. eb-shop.js owns the cart conversation; this only hands it the
     lines. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-eb-add]');
    if (!form) return;
    var card = form.closest('[data-eb-pcard]');
    var bundle = card && card.querySelector('[data-eb-bundle]');
    if (!bundle) return;
    var extras = ticked(bundle).filter(function (it) { return it.getAttribute('data-variant'); }).map(function (it) {
      return { id: parseInt(it.getAttribute('data-variant'), 10), quantity: 1 };
    });
    if (!extras.length) return;
    form.dispatchEvent(new CustomEvent('eb:cart:extras', { bubbles: true, detail: { items: extras } }));
  });

  /* swatches on a card: a picker for the eye — the photograph follows the
     colour, and the card opens the product page on that colour. Nothing is
     added to a cart from here; the product page still chooses. */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.eb-pcard__swatches [role="radio"]');
    if (!sw) return;
    e.preventDefault();
    slice(sw.parentNode.querySelectorAll('[role="radio"]')).forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
    sw.setAttribute('aria-checked', 'true');

    var card = sw.closest('[data-eb-pcard]');
    if (!card) return;
    /* 库存那句跟着颜色走：选到售罄的颜色换成「Gold sold out」，选回来还原。
       预售那句（--pre）是发货日，不归颜色管，不动。 */
    var stock = card.querySelector('.eb-pcard__eyebrow .eb-stock:not(.eb-stock--pre)');
    if (stock) {
      if (!stock.hasAttribute('data-was')) {
        stock.setAttribute('data-was', stock.textContent);
        stock.setAttribute('data-was-class', stock.className);
      }
      var sold = sw.getAttribute('data-sold');
      stock.className = sold ? 'eb-stock eb-stock--out' : stock.getAttribute('data-was-class');
      stock.textContent = sold || stock.getAttribute('data-was');
    }
    var src = sw.getAttribute('data-src');
    var img = card.querySelector('.eb-pcard__img--primary');
    if (src && img) {
      var set = sw.getAttribute('data-srcset');
      if (set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
      img.src = src;
      /* The hover image is a lifestyle shot in whichever colour it was taken
         in; once a colour is chosen it would show the wrong bike. */
      card.classList.add('is-swatched');
    }
    var href = sw.getAttribute('data-href');
    var link = card.querySelector('.eb-pcard__title a');
    if (href && link) link.setAttribute('href', href);
  });
  /* Warm the image while the pointer is on its way, so the swap is instant. */
  document.addEventListener('pointerover', function (e) {
    var sw = e.target.closest && e.target.closest('.eb-pcard__swatches [data-src]');
    if (!sw || sw.ebWarm) return;
    sw.ebWarm = true;
    new Image().src = sw.getAttribute('data-src');
  });

  paintCompare();
  document.addEventListener('shopify:section:load', function () {
    paintCompare(); slice(document.querySelectorAll('[data-eb-bundle]')).forEach(recalc);
    /* The editor replaces a section's markup wholesale, so a tray that was
       rendered inside one is a new element with no listeners on it. */
    tray();
  });

  /* ══ THE COMPARE TRAY ══════════════════════════════════════════════════
     The other half of a control that has shipped since v4.0. The toggle, the
     three-slot limit, "a fourth replaces the oldest" and the change event
     were all here already — with nothing listening and no tray on the page,
     so ticking compare on a card did nothing a visitor could see.

     The tray RENDERS FROM THE EVENT, never from its own copy of the state.
     Two lists of the same selection is how a tray and a set of cards end up
     disagreeing after a back button. */
  function tray() {
    var box = document.querySelector('[data-eb-compare-tray]');
    /* Once per tray. The editor calls this again on every section render and
       a second set of listeners on the same box paints it twice. */
    if (!box || box.ebTrayBound) return;
    box.ebTrayBound = true;
    var slots = box.querySelector('[data-eb-compare-slots]');
    var count = box.querySelector('[data-eb-compare-count]');
    var go = box.querySelector('[data-eb-compare-go]');
    var clear = box.querySelector('[data-eb-compare-clear]');

    function paint(sel, max) {
      box.classList.toggle('is-open', sel.length > 0);
      if (count) count.textContent = sel.length + ' / ' + max;
      if (go) {
        /* One bike is not a comparison. The button is present but refuses,
           which says what is needed; hiding it would only say nothing. */
        go.disabled = sel.length < 2;
        var base = go.getAttribute('data-href') || '/pages/compare';
        go.setAttribute('data-to', base + '?models=' +
          sel.map(function (m) { return encodeURIComponent(m.handle); }).join(','));
      }
      if (!slots) return;
      slots.textContent = '';
      for (var i = 0; i < max; i++) {
        var m = sel[i];
        var cell = document.createElement('div');
        cell.className = 'eb-compare-slot' + (m ? ' is-filled' : '');
        if (m) {
          if (m.image) {
            var img = document.createElement('img');
            img.src = m.image; img.alt = ''; img.loading = 'lazy';
            cell.appendChild(img);
          }
          var x = document.createElement('button');
          x.type = 'button';
          x.setAttribute('aria-label', (box.getAttribute('data-remove') || 'Remove') + ' ' + m.name);
          x.setAttribute('data-eb-compare-drop', m.handle);
          x.innerHTML = '<svg class="eb-icon eb-icon--xs" aria-hidden="true"><use href="#i-close"/></svg>';
          cell.appendChild(x);
        } else {
          var n = document.createElement('span');
          n.className = 'eb-compare-slot__n';
          n.textContent = i + 1;
          cell.appendChild(n);
        }
        slots.appendChild(cell);
      }
    }

    document.addEventListener('eb:compare:change', function (e) {
      paint(e.detail.selected || [], e.detail.max || 3);
    });
    /* AND PAINT WHAT IS ALREADY CHOSEN. The selection lives in localStorage so
       it survives the walk from one bike to the next — but the first
       paintCompare() runs before this listener exists, so arriving on the next
       page with two bikes picked showed an empty tray until something was
       clicked. The tray is the reason the selection is worth keeping. */
    paint(read(), MAX);
    box.addEventListener('click', function (e) {
      var drop = e.target.closest('[data-eb-compare-drop]');
      if (drop) {
        var btn = document.querySelector('[data-eb-compare="' + drop.getAttribute('data-eb-compare-drop') + '"]');
        if (btn) { btn.click(); return; }
      }
      if (clear && e.target.closest('[data-eb-compare-clear]')) {
        slice(document.querySelectorAll('[data-eb-compare][aria-pressed="true"]'))
          .forEach(function (b) { b.click(); });
      }
      if (go && e.target.closest('[data-eb-compare-go]') && !go.disabled) {
        window.location.href = go.getAttribute('data-to');
      }
    });
  }
  tray();

})();
